import axios from "axios";
import { Markup } from "interweave";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import swal from "sweetalert";
import { serverInfo } from "../../../../App";
import flag from "../../../../assets/images/Auditions/flag.png";
import flag4 from "../../../../assets/images/Interval-01.1.png";
import flag2 from "../../../../assets/images/Maximum-Time-01.1.png";
import flag3 from "../../../../assets/images/Minimum-Time-01.1.png";
import vector from "../../../../assets/images/meetupEvent/Vector.png";
import ScreenRecordShow from "../../../Reuseable/ScreenRecordShow";
import ContdownTimerRender from "../../../../HelperComponent/ContdownTimerRender";
import Countdown from "react-countdown";

const StarMeetUpEvent = (props) => {
  const { imageCdnUrl } = useContext(serverInfo);
  const history = useHistory();

  const [event, setEvent] = useState([]);
  const [slot, setSlot] = useState([]);
  const [count, setCount] = useState("");
  const [eventTime, setEventTime] = useState('');
  const [myInfo, setMyInfo] = useState({});
  const authName = localStorage.getItem("auth_name");
  const [callJoinBuffer, setCallJoinBuffer] = useState(false);
  useEffect(() => {
    const event_id = props.match.params.id;

    axios.get(`/api/star/meetup_event/details/${event_id}`).then((res) => {
      if (res.data.status === 200) {
        setEvent(res.data.meetup);
        setEventTime(res.data.meetup?.event_date);
      }
    });
    axios.get(`/api/star/meetup_event_slots/${event_id}`).then((res) => {
      if (res.data.status === 200) {
        setSlot(res.data.meetup);
        setCount(res.data.count);
      }
    });

    axios.get(`/api/user_info`).then((res) => {
      if (res.data.status === 200) {
        setMyInfo(res.data.users);
      }
    });
  }, [props.match.params.id, history]);

  const handleClick = () => {
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios
        .get(`/api/star/meetup_event/set_approve/${event.id}`)
        .then((res) => {
          if (res.data.status === 200) {
            swal("Success", res.data.message, "success");
            history.push("/superstar/meetup-events/approved");
          }
        });
    });
  };

  /**
   * time count
   */
  const timeCount = () => {
    let eventDate = event.event_date;
    let endTime = event.end_time;

    let end = moment(eventDate + " " + endTime);
    let now = moment();

    if (!eventDate || !endTime || !end.isValid()) {
      return 0;
    }

    return Math.max(0, end.valueOf() - now.valueOf());
  };

  // let minute = timeCount() / 60000

  const joinRoute = (room_id) => {
    // alert()
    setCallJoinBuffer(true);
    axios
      .get("/sanctum/csrf-cookie")
      .then((response) => {
        axios.get(`/api/sdk/get-token/admin`).then((res) => {
          // alert(res.data.token)
          setCallJoinBuffer(false);
          window.open(
            `/video-meeting?token=${
              res.data.token
            }&meetingId=${room_id}&webcamEnabled=true&micEnabled=true&name=${authName}&time=${
              timeCount() / 60000
            }&whiteboardEnabled=false&canDrawOnWhiteboard=true&canToggleWhiteboard=true&canChangeLayout=true&canPin=true&askJoin=false&participantCanToggleOtherMic=true&participantCanToggleOtherWebcam=true&canRemoveOtherParticipant=true`
          );
        });
      })
      .catch((err) => {
        alert("network problem");
      });
  };

  const setReject = () => {
    axios.get("/sanctum/csrf-cookie").then((response) => {
      axios.get(`/api/star/rejectMeetup/${event.id}`).then((res) => {
        if (res.data.status === 200) {
          swal("Success", res.data.message, "success");
          history.goBack();
        }
      });
    });
  };

  // new countdown

  const startTime = moment(eventTime).format("LL") + " " + event.start_time;

  const countDownDate = new Date(startTime).getTime();
  const endTime = new Date(moment(eventTime).format("LL") + " " + event.end_time).getTime();

  return (
    <>
      <div className="AS">
        <div className="container-fluid">
          <div className="row mb-3">
            <div className="col-sm-12 col-md-12 col-lg-6 m-0 mb-3 ">
              <div className="card card-bg p-2">
                <img
                  src={imageCdnUrl + event.banner}
                  alt=""
                  className="img-fluid Banner-SME-b "
                />
                <Countdown
                  date={startTime}
                  renderer={ContdownTimerRender}
                />
              </div>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-6 m-0 mb-3">
              <div className="registration-head  card-bg mb-1">
                <h5 className="text-warning fw-bold p-2">Registration </h5>
              </div>

              <div className="row registration-body  card-bg m-0 pt-3">
                <div className="col-md-6 m-0 ">
                  <div className="d-flex registration-btn p-2">
                    <div className="mx-3 mt-2">
                      <span className="text-light">
                        <img src={flag} alt="" className="PriceTage" />
                      </span>
                    </div>
                    <div className=" mx-1">
                      <span className="text-light">Registration Start:</span>
                      <br></br>
                      <span className=" text-warning fw-bold">
                        {moment(event.registration_start_date).format("LL")}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 m-0 ">
                  <div className="d-flex registration-btn p-2">
                    <div className="mx-3 mt-2">
                      <span className="text-light">
                        <img src={flag} alt="" className="PriceTage" />
                      </span>
                    </div>
                    <div className=" mx-1">
                      <span className="text-light">Registration End:</span>
                      <br></br>
                      <span className=" text-warning fw-bold">
                        {moment(event.reg_end_date).format("LL")}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 m-0 ">
                  <div className="d-flex registration-btn p-2">
                    <div className="mx-3 mt-2">
                      <span className="text-light">
                        <img src={flag2} alt="" className="PriceTage" />
                      </span>
                    </div>
                    <div className=" mx-1">
                      <span className="text-light">Type:</span>
                      <br></br>
                      <span className=" text-warning fw-bold">
                        {event.meetup_type}
                      </span>
                    </div>
                  </div>
                </div>

                <div className="col-md-6 m-0 ">
                  <div className="d-flex registration-btn p-2">
                    <div className="mx-3 mt-2">
                      <span className="text-light">
                        <img src={flag3} alt="" className="PriceTage" />
                      </span>
                    </div>
                    <div className=" mx-1">
                      <span className="text-light">Total Seat: </span>
                      <br></br>
                      <span className=" text-warning fw-bold">
                        {event.total_seat}
                      </span>
                    </div>
                  </div>
                </div>

                {event.meetup_type === "Offline" ? (
                  <div className="col-md-12 m-0 ">
                    <div className="d-flex registration-btn p-2">
                      <div className="mx-3 mt-2">
                        <span className="text-light">
                          <img src={flag4} alt="" className="PriceTage" />
                        </span>
                      </div>
                      <div className=" mx-1">
                        <span className="text-light">Venue: </span>
                        <br></br>
                        <span className=" text-warning fw-bold">
                          {event.venue}
                        </span>
                      </div>
                    </div>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>

          <div className="row mt-1">
            <div className="col-md-12">
              <div className="card card-bg shadow">
                <div className="card-body">
                  <h5 className="text-light pb-3">
                    {event.title} &nbsp;
                    <sub className="text-warning">({event.meetup_type})</sub>
                  </h5>

                  <h5 className="text-warning">Instruction</h5>
                  <div className="under-line"></div>
                  <p className="text-light mt-2">
                    <Markup content={event.instruction} />
                  </p>

                  <h5 className="text-warning">Description</h5>
                  <div className="under-line"></div>
                  <p className="text-light mt-2">
                    <Markup content={event.description} />
                  </p>

                  <div className="col-md-4 card card-bg-event head-line my-2 mt-4 row justify-content-between mx-0">
                    <h5 className="text-warning pt-2 ">Event Date</h5>
                    <p className="text-light fw-bold pt-2">
                      {moment(event.event_date).format("LL")} |{" "}
                      {moment(event.start_time, "HH:mm:ss").format("hh:mm A")}-
                      {moment(event.end_time, "HH:mm:ss").format("hh:mm A")}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {event.meetup_type == "Online" ? (
            <ScreenRecordShow roomId={event.event_link} />
          ) : (
            <></>
          )}

          <div className="col-md-12">
            <div className="card card-bg solt-card">
              <div className="card-body">
                <h3 className="text-warning">
                  <img src={vector} alt="clock" className="mx-2"></img>
                  Slots
                  <sub>
                    ({count}/{event.total_seat})
                  </sub>
                </h3>
                <div className="row my-3">
                  {slot.map((user, index) => (
                    <div className="col-md-2 col-sm-3 ">
                      <p className="sold-small-card fw-bold">
                        <img
                          src={imageCdnUrl + user.user?.image}
                          className="img-fluid mx-2 p-1"
                          alt=""
                          style={{
                            height: "50px",
                            width: "50px",
                            borderRadius: "50%",
                          }}
                        />
                        {user.user?.first_name} {user.user?.last_name}
                      </p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-7 row mx-auto">
              {Number(event.status) === 2 &&
              countDownDate <= new Date().getTime() && endTime >= new Date().getTime()? (
                <div className="mt-3 col-md-4 mx-auto">
                  {event.meetup_type == "Offline" ? null : (
                    <button
                      className="btn btnConfirm w-100 fw-bold px-5"
                      onClick={() => joinRoute(event.event_link)}
                    >
                      {callJoinBuffer && (
                        <div
                          class="spinner-border text-dark"
                          role="status"
                          style={{
                            height: "10px",
                            width: "10px",
                            marginRight: "10px",
                          }}
                        >
                          <span class="sr-only">Loading...</span>
                        </div>
                      )}
                      Join Now
                    </button>
                  )}
                </div>
              ) : Number(event.status) < 2 ? (
                <>
                  {event.status < 1 ? (
                    <div className="mt-3 col-md-4">
                      <button
                        className="btn btnSave w-100 fw-bold"
                        onClick={handleClick}
                      >
                        Approved
                      </button>
                    </div>
                  ) : (
                    <></>
                  )}
                  <div className="col-md-4 mt-3">
                    <Link to={`/superstar/meetup-events/edit/${event.id}`}>
                      <button className="btn w-100 btnEdit  fw-bold ">
                        Edit
                      </button>
                    </Link>
                  </div>
                  <div className="col-md-4 mt-3">
                    <button
                      className="btn w-100 btnDecline text-light fw-bold"
                      onClick={setReject}
                    >
                      Reject
                    </button>
                  </div>
                </>
              ) : Number(event.status) === 9 ? (
                <></>
              ) : (
                <>
                  {" "}
                  {event.meetup_type == "Offline" ? null : (
                    <div className="mt-3 col-md-4 mx-auto">
                      <button
                        className="btn btn-warning btnFinalWidth w-100 fw-bold px-5"
                        disabled
                      >
                        Join Now
                      </button>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default StarMeetUpEvent;
